export default Object.freeze({
  UPDATE_MUTATION: 'UPDATE_MUTATION',
})
